// src\modules\IntegratedMessaging\components\interaction\DropdownActions.tsx

import { faEllipsisVertical, faPen, faXmark, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { usePermissions } from '@shared/hooks/usePermissions';

interface Props {
  isActive: boolean;
  onToggleActive: () => void;
  onEdit: () => void;
}

export const DropdownActions = ({ isActive, onToggleActive, onEdit }: Props) => {
  const { t } = useTranslation('integratedmessagingModule');
  const { canAccess } = usePermissions();

  // 🎯 Verificar permisos de mensajerías
  const canEdit = canAccess(['tenant', 'tenant_3pl'], ['shipping.couriers.edit']);
  const canActivate = canAccess(['tenant', 'tenant_3pl'], ['shipping.couriers.activate']);

  // Si no tiene ningún permiso, no mostrar el dropdown
  if (!canEdit && !canActivate) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="hover:bg-muted rounded-md px-2" data-testid="dropdown-trigger">
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-44 border-card-border" data-testid="dropdown-content">
        {/* Editar - requiere shipping.couriers.edit */}
        {canEdit && (
          <DropdownMenuItem onClick={onEdit}>
            <FontAwesomeIcon icon={faPen} className="mr-2 w-3.5" />
            {t('table.edit')}
          </DropdownMenuItem>
        )}

        {/* Activar/Desactivar - requiere shipping.couriers.activate */}
        {canActivate && (
          <DropdownMenuItem onClick={onToggleActive}>
            <FontAwesomeIcon icon={isActive ? faXmark : faCheck} className="mr-2 w-3.5" />
            {isActive ? t('table.deactivate') : t('table.activate')}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
